// Action creators for the "What's new" guided tour (see reducers/guidedTour.js).
export const startTour = () => ({ type: "GUIDED_TOUR_START" });

export const setTourStep = (stepIndex) => ({
  type: "GUIDED_TOUR_SET_STEP",
  stepIndex,
});

export const stopTour = () => ({ type: "GUIDED_TOUR_STOP" });
